"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.liveVideoStatusMapper = void 0;
const enum_mapper_1 = require("../../utils/enum-mapper");
const globalTypes_1 = require("../generated/globalTypes");
const common_1 = require("@wix/wix-vod-constants/common");
exports.liveVideoStatusMapper = new enum_mapper_1.EnumMapper({
    [globalTypes_1.LiveStatus.DVR_PROCESSING]: common_1.LIVE_VIDEO_STATUS.FINISHED,
    [globalTypes_1.LiveStatus.STREAMING]: common_1.LIVE_VIDEO_STATUS.IN_PROGRESS,
    [globalTypes_1.LiveStatus.SCHEDULED]: common_1.LIVE_VIDEO_STATUS.SCHEDULED,
    [globalTypes_1.LiveStatus.FINISHED]: common_1.LIVE_VIDEO_STATUS.FINISHED,
    [globalTypes_1.LiveStatus.PENDING]: common_1.LIVE_VIDEO_STATUS.PENDING,
    [globalTypes_1.LiveStatus.RECONNECTING]: common_1.LIVE_VIDEO_STATUS.IN_PROGRESS,
    [globalTypes_1.LiveStatus.EXPIRED]: common_1.LIVE_VIDEO_STATUS.FINISHED,
});
//# sourceMappingURL=live-video-status.js.map